// Module
var code = "<div class=\"abx-dashboard-container\"> <abx-dashboard ng-if=\"vm.buildings\" abx-buildings=\"vm.buildings\"> </abx-dashboard> <div class=\"abx-dashboard-preloader\" ng-hide=\"vm.buildings\"> <md-progress-circular class=\"md-accent\"></md-progress-circular> </div> </div> ";
// Exports
module.exports = code;